import React from 'react';
import clsx from 'clsx';

interface FieldProps {
  label: string;
  htmlFor?: string;
  hint?: React.ReactNode;
  error?: string | null;
  required?: boolean;
  children: React.ReactNode;
}

export function Field({ label, htmlFor, hint, error, required, children }: FieldProps) {
  return (
    <div className={clsx('form-group')}>
      <label className="form-label" htmlFor={htmlFor}>
        {label}
        {required ? <span style={{ color: 'var(--danger)' }}> *</span> : null}
      </label>
      {children}
      {hint && !error ? <div className="form-hint">{hint}</div> : null}
      {error ? <div className="form-error">{error}</div> : null}
    </div>
  );
}
